<template>
  <div class="attact-container">
    <swiper :options="swiperOption" class="big-swiper" ref="mySwiper">
      <swiper-slide class="slide" v-for="(item, index) in list" :key="index">
        <img class="slide_item" :src="item.imgUrl" />
      </swiper-slide>
      <!-- <swiper-slide v-for="(item,index) in list" :key="index">
        <img :src="item.img" alt="">
      </swiper-slide>-->
    </swiper>
    <swiper
      class="small-swiper gallery-thumbs"
      :options="swiperOptionThumbs"
      ref="swiperThumbs"
    >
      <swiper-slide
        class="slide"
        v-for="(sitem, sindex) in list"
        :key="'s' + sindex"
      >
        <div
          class="slide_item"
          :style="{ backgroundImage: 'url(' + sitem.imgUrl + ')' }"
        ></div>
      </swiper-slide>
    </swiper>
    <div class="text-wrap color-fff fs-14">
      <div class="flex-container">
        <span>{{ $t("public.name") + ":" + $t("public.exhibitionName") }}</span>
        <!-- <span>Name：The 22<i class="up_text">nd</i> Guangzhou International Automobile Exhibition</span> -->
      </div>
      <div class="flex-container">
        <span>{{
          $t("public.venue") + ":" + $t("public.exhibitionVenue")
        }}</span>
        <!-- <span>Venue：China Import and Export Fair Complex（Canton Fair Complex）</span> -->
      </div>
      <div class="flex-container">
        <span>{{ $t("public.date") + ":" + $t("public.openDate") }}</span>
        <!-- <span>Date：2024.11.15-24</span> -->
      </div>
    </div>
    <div class="btn-wrap">
      <span class="btn-down media_font_size_50">
        <a
          :href="(_i18n.locale=='zh'?'https://vrshow-1255573444.cos.ap-guangzhou.myqcloud.com/autoShow/exhibitor/2024%E5%B9%BF%E5%B7%9E%E8%BD%A6%E5%B1%95%E6%8B%9B%E5%B1%95%E5%87%BD.pdf':'https://vrshow-1255573444.cos.ap-guangzhou.myqcloud.com/autoShow/invitation/en/24/2024%E5%B9%BF%E5%B7%9E%E8%BD%A6%E5%B1%95%E6%8B%9B%E5%B1%95%E5%87%BD%EF%BC%88%E8%8B%B1%E6%96%87%E7%89%88%EF%BC%89.pdf')"
          target="_blank"
          >{{ $t("public.download") }}</a
        >
        <i class="el-icon-download"></i>
      </span>
    </div>
  </div>
</template>

<script>
export default {
  mounted() {
    const mySwiper = this.$refs.mySwiper.swiper;
    const swiperThumbs = this.$refs.swiperThumbs.swiper;
    console.log(mySwiper, swiperThumbs);
    mySwiper.controller.control = swiperThumbs;
    swiperThumbs.controller.control = mySwiper;
    this.list = this._i18n.locale == "zh" ? this.listZh : this.listEn;
  },
  data() {
    return {
      swiperOption: {
        // 所有的参数同 swiper 官方 api 参数
        loop: true,
        loopedSlides: 3, // looped slides should be the same
        spaceBetween: 10,
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        },
      },
      swiperOptionThumbs: {
        loop: true,
        loopedSlides: 3, // looped slides should be the same
        spaceBetween: 20,
        centeredSlides: true,
        slidesPerView: "auto",
        touchRatio: 0.2,
        slideToClickedSlide: true,
        autoplay: false,
      },
      list: [],
      listEn: [
        {
          id: 1,
          imgUrl:
            "https://vrshow-1255573444.cos.ap-guangzhou.myqcloud.com/autoShow/invitation/en/24/1.png",
        },
        {
          id: 2,
          imgUrl:
            "https://vrshow-1255573444.cos.ap-guangzhou.myqcloud.com/autoShow/invitation/en/24/2.png",
        },
        {
          id: 3,
          imgUrl:
            "https://vrshow-1255573444.cos.ap-guangzhou.myqcloud.com/autoShow/invitation/en/24/3.png",
        },
        {
          id: 4,
          imgUrl:
            "https://vrshow-1255573444.cos.ap-guangzhou.myqcloud.com/autoShow/invitation/en/24/4.png",
        },
        {
          id: 5,
          imgUrl:
            "https://vrshow-1255573444.cos.ap-guangzhou.myqcloud.com/autoShow/invitation/en/24/5.png",
        },
        {
          id: 6,
          imgUrl:
            "https://vrshow-1255573444.cos.ap-guangzhou.myqcloud.com/autoShow/invitation/en/24/6.png",
        },
      ],
      listZh: [
        {
          id: 1,
          imgUrl: "https://vrshow-1255573444.cos.ap-guangzhou.myqcloud.com/autoShow/attact/24/1.png",
        },
        {
          id: 2,
          imgUrl: "https://vrshow-1255573444.cos.ap-guangzhou.myqcloud.com/autoShow/attact/24/2.png",
        },
        {
          id: 3,
          imgUrl: "https://vrshow-1255573444.cos.ap-guangzhou.myqcloud.com/autoShow/attact/24/3.png",
        },
        {
          id: 4,
          imgUrl: "https://vrshow-1255573444.cos.ap-guangzhou.myqcloud.com/autoShow/attact/24/4.png",
        },
        {
          id: 5,
          imgUrl: "https://vrshow-1255573444.cos.ap-guangzhou.myqcloud.com/autoShow/attact/24/5.png",
        },
        {
          id: 6,
          imgUrl: "https://vrshow-1255573444.cos.ap-guangzhou.myqcloud.com/autoShow/attact/24/6.png",
        },
        // {
        //   id: 7,
        //   imgUrl: require("../../../assets/img/attact/23/7.jpg")
        // },
        // {
        //   id: 8,
        //   imgUrl: require("../../../assets/img/attact/23/8.jpg")
        // },
        // {
        //   id: 9,
        //   imgUrl: require("../../../assets/img/attact/23/9.jpg")
        // },
        // {
        //   id: 10,
        //   imgUrl: require("../../../assets/img/attact/23/10.jpg")
        // },
        // {
        //   id:11,
        //   imgUrl: require("../../../assets/img/attact/23/11.jpg")
        // },
        // {
        //   id: 12,
        //   imgUrl: require("../../../assets/img/attact/23/12.jpg")
        // }
      ],
    };
  },
  methods: {
    handelPre() {
      this.$refs.mySwiper.swiper.slidePrev();
    },
    handeNext() {
      this.$refs.mySwiper.swiper.slideNext();
    },
  },
};
</script>

<style lang="scss">
.attact-container {
  width: 100%;
  .big-swiper {
    // width: 1200px;
    display: flex;
    align-items: center;
    .slide {
      // width: 1200px;
      // height: 900px;
      display: flex;
      justify-content: center;
      .slide_item {
        // width: 100%;
        // height: auto;
        background: #fff;
        background-size: cover;
        background-position: center;
      }
    }
    .my-swiper-pre,
    .my-swiper-next {
      position: absolute;
      top: 50%;
      width: 27px;
      height: 44px;
      margin-top: -22px;
      z-index: 10;
      cursor: pointer;
      -moz-background-size: 27px 44px;
      -webkit-background-size: 27px 44px;
      background-size: 27px 44px;
      background-position: center;
      background-repeat: no-repeat;
      font-size: 150px;
      color: #fff;
    }
    .my-swiper-next {
      right: 5%;
    }
  }
  .small-swiper {
    height: 240px;
    margin: 30px 0px;
    .slide {
      width: 320px;
      height: 240px;
      .slide_item {
        // width: 100%;
        height: 240px;
        background: #fff;
        background-size: cover;
        background-position: center;
      }
    }
  }
  .text-wrap {
    display: flex;
    align-items: center;
    width: 100%;
    justify-content: space-between;
    > div {
      align-items: flex-start;
    }
  }
  .btn-wrap {
    display: flex;
    .btn-down {
      padding: 20px 20px;
      height: 60px;
      color: #fff;
      background: #42abff;
      font-size: 24px;
      line-height: 60px;
      display: flex;
      align-items: center;
      border-radius: 30px;
      justify-content: center;
      margin: 70px 0px;
      > a {
        margin-right: 5px;
        color: #fff;
      }
    }
  }
}

@media screen and (max-width: 1000px) {
  .attact-container {
    .text-wrap {
      display: flex;
      align-items: center;
      flex-direction: column;
      > span {
        text-align: left;
        color: #fff;
        font-size: 50px;
        width: 100%;
        margin: 20px;
        //   line-height: 50px;
      }
    }
    .btn-wrap {
      .btn-down {
        padding: 50px 20px;
      }
    }
  }
}
.up_text {
  vertical-align: super;
  font-size: 12px;
}
.swiper-wrapper {
  align-items: center !important;
}
</style>



// WEBPACK FOOTER //
// attact.vue?7cb64c28